import React from 'react';
import { CandlestickChart } from 'lucide-react';
export function Footer() {
  const currentYear = new Date().getFullYear();
  return <footer className="w-full py-12 px-6 md:px-12 border-t border-carbon-800 bg-carbon-950 relative z-20" data-id="element-25">
      <div className="max-w-7xl mx-auto flex flex-col items-center gap-8" data-id="element-26">
        <div className="flex items-center gap-3 opacity-50 grayscale hover:grayscale-0 hover:opacity-100 transition-all duration-500" data-id="element-27">
          <CandlestickChart className="w-5 h-5 text-gold-500" data-id="element-28" />
          <span className="font-serif text-lg font-semibold tracking-wide text-gold-200" data-id="element-29">
            DAY TRADER ORO
          </span>
        </div>

        <div className="max-w-2xl text-center flex flex-col gap-4" data-id="element-30">
          <p className="text-sm text-gray-400 leading-relaxed font-medium" data-id="element-31">
            El trading tiene riesgo. Los resultados pueden variar según el
            capital, la gestión y las condiciones del mercado.
          </p>
          <p className="text-xs text-carbon-600 leading-relaxed" data-id="element-32">
            La información proporcionada en este sitio web es solo para fines
            educativos e informativos. Asegurate de comprender completamente los
            riesgos involucrados antes de operar.
          </p>
        </div>

        <div className="text-xs text-carbon-700" data-id="element-33">
          &copy; {currentYear} Day Trader Oro. Todos los derechos reservados.
        </div>
      </div>
    </footer>;
}